<template>
    <div
        class="md-map layout2 school mg-bg"
        :style="{ ...spaceStyle, ...colorStyle }"
        v-if="schoolGroups && schoolGroups.length"
    >
        <div class="school-container" :class="{ 'f-col': !fullColumn}">
            <site-title class="mg-title" v-if="title" :title="title" />
            <div class="school-content" :style="contentStyle">
                <map-tab
                    v-if="schoolGroups && schoolGroups.length"
                    v-model:replace="replace"
                    :tabs="schoolGroups"
                    @updateMarkerEvent="updateMarkerEvent"
                    @updateMarkerData="updateMarkerData"
                    @doMapEvent="doMapEvent"
                    @updateMapClickEvent="updateMapClickEvent"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import common from '../index';
import mapTab from './map-tab.vue';

export default {
    mixins: [common],
    data() {
        return {
            requestAction: { tab: ['getSchoolData'] },
        }
    },
    components: {
        mapTab
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {}
        }),
        schoolGroups() {
            return this.tabs.find(tab => tab.type === 'school')?.groups || [];
        }
    },
    async created() {
        this.selectTab = 'school';
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-map.layout2 {
    .mg-title {
        color: var(--g-primary-color);
        letter-spacing: normal;
        margin-bottom: 40px;
        padding-bottom: 0;
        @include webkitBox(2);
        @include media-800 {
            margin-bottom: 20px;
        }
    }
}
</style>
